import useClientApi from '@/hooks/use-client-api'
import { useSessionQuery } from '@/hooks/use-session-query'
import { ExpiringPoliciesResponse } from '../types'

interface UseGetExpiringPoliciesProps {
  enabled?: boolean
}

export default function useGetExpiringPolicies(
  props: UseGetExpiringPoliciesProps
) {
  const { API } = useClientApi()
  return useSessionQuery<ExpiringPoliciesResponse>({
    queryKey: ['get-expiring-policies'],
    queryFn: async () => {
      const response = await API.get(`/applications/expiring-policies`)
      return response.data
    },
    enabled: props.enabled,
    staleTime: 0,
    gcTime: 0,
  })
}
